import type { CohortUrgencyCopy } from 'pages/certificates/experiments/mccerts-3290_v1_cohort_urgency'
import { formatEnrollmentDeadline } from '../format/formatCohortDate'
import type { CohortConfig, EnrollmentStateResult } from '../types'

export type UrgencyFooterCopy = { headline: string; subline?: string }

const DATE_TOKEN = /\{\{date\}\}/g

export const getUrgencyFooterCopy = (
  footer: CohortUrgencyCopy['footer'],
  config: CohortConfig,
  enrollment: EnrollmentStateResult,
): UrgencyFooterCopy | null => {
  if (!('deadline' in enrollment) || !footer) return null

  const date = formatEnrollmentDeadline(enrollment.deadline, config.timezone)
  const fill = (text: string) => text.replace(DATE_TOKEN, date)

  return {
    headline: fill(footer.headline),
    subline: footer.subline ? fill(footer.subline) : undefined,
  }
}
